// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Krsa","insightsList":"newBusinessInsightsMenu_insightsList__-u9Yw","active":"newBusinessInsightsMenu_active__2883l"};